import { Component, Input, output, inject } from '@angular/core';
import { ISirena } from 'modelos/src';
import { HelperService } from 'src/app/auxiliares/servicios/helper.service';
import { colorSirena } from 'src/app/auxiliares/mapbox/sirena-estado';

const HEX: Record<string, string> = {
  azul: '#1e88e5',
  verde: '#2e7d32',
  amarilla: '#f9a825',
  roja: '#e53935',
};

@Component({
  selector: 'app-isla',
  templateUrl: './isla.component.html',
  styleUrl: './isla.component.scss',
  standalone: false,
})
export class IslaComponent {
  helper = inject(HelperService);

  @Input() sirena?: ISirena & { estado: string };
  readonly cerrarChange = output<boolean>();

  /** Color de acento según el estado de la sirena. */
  public colorEstado(): string {
    return this.sirena ? HEX[colorSirena(this.sirena)] : '#9e9e9e';
  }

  public cerrar(): void {
    this.cerrarChange.emit(true);
  }
}
